export default __webpack_public_path__ + "static/media/picto_X-CV.f03fcde2.svg";